import { getPrivacyFlag, updatePrivacyFlag } from '@/api/global'
import { privacyState, modifyPrivacyLocal } from '@/utils/privacy-state'

export default () => {
  // 远程获取
  const getPrivacyRemote = () => {
    return new Promise((resolve) => {
      getPrivacyFlag().then((res) => {
        const { code, data } = res
        if (code === 1) {
          modifyPrivacyLocal(data)
          resolve(data)
        }
      })
    })
  }
  // 远程更新
  const modifyPrivacyRemote = (val) => {
    return updatePrivacyFlag(val).then((res) => {
      const { code, data } = res
      if (code === 1 && data) {
        modifyPrivacyLocal(val)
      }
    })
  }

  return {
    privacyState,
    getPrivacyRemote,
    modifyPrivacyRemote,
  }
}
